import { Component } from '@angular/core';
import { VehicleInsuranceDeleteButtonComponent } from '../vehicle-insurance-delete-button/vehicle-insurance-delete-button.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { BaseListItemMenuComponent } from '../../../../../shared/base-classes/base-list-item-menu.component';

@Component({
	selector: 'app-vehicle-insurances-list-item-menu',
	templateUrl: 'vehicle-insurances-list-item-menu.component.html',
	imports: [
		VehicleInsuranceDeleteButtonComponent,
		ListItemMenuContainerComponent,
	],
})
export class VehicleInsurancesListItemMenuComponent extends BaseListItemMenuComponent {}
